import axios from 'axios'
import { clearAuthSession, getStorageSync } from '@/utils/uni-app'

// 创建axios实例
const api = axios.create({
  baseURL: '/api', // 开发环境走 vue.config.js 的 devServer 代理到 http://localhost:8081
  timeout: 800000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    if (String(config.data?.platform || config.params?.platform || '').toLowerCase() === 'apinebula') config.timeout = 35 * 60 * 1000
    // 使用getStorageSync获取token，确保正确处理JSON格式
    const token = getStorageSync('token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('API请求失败，HTTP 状态:', error.response?.status || 'network')
    if (error.response?.status === 401) {
      clearAuthSession()
      const currentRoute = window.router?.currentRoute
      if (currentRoute?.meta?.requiresAuth && currentRoute.path !== '/login') {
        window.router.replace({ path: '/login', query: { reason: 'session_expired' } })
      }
    }
    return Promise.reject(error)
  }
)

// 添加文件上传方法
api.upload = (url, data) => {
  return api({
    method: 'post',
    url,
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 添加表单数据提交方法
api.formPost = (url, data) => {
  return api({
    method: 'post',
    url,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }]
  })
}

// 添加表单数据GET方法
api.formGet = (url) => {
  return api({
    method: 'get',
    url
  })
}

// 图片上传接口
api.uploadImage = (file) => {
  const formData = new FormData()
  formData.append('image', file)
  return api({
    method: 'post',
    url: '/liner/upload-image',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 图片删除接口
api.deleteImage = (url) => {
  return api({
    method: 'delete',
    url: '/liner/delete-image',
    params: { url }
  })
}

export default api
